import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {HttpClient} from '@angular/common/http';
import {appConfig} from '../app.config';
import {ItemSummaryScheduleNumberService} from './item-summary-schedule-number.service';
import {EquipScheduleA} from '../domain/item';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryScheduleNumberServiceImpl extends ItemSummaryScheduleNumberService {

  constructor(private http: HttpClient) {
    super();
  }

  public getSchedulesForSiteHoldingPenAndContract(siteId: number, contractId: number): void {
    let url = '/api/schedule-numbers/sites/{siteId}/holding-pen/contract/{contractId}';
    url = url.replace('{siteId}', String(siteId)).replace('{contractId}', String(contractId));
    this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getSchedulesForSiteHoldingPenAndContract', []))
      )
      .subscribe(response => {
        const schedules = response as EquipScheduleA[];
        this.siteHoldingPenSchedulesCallback.next(schedules);
      });
  }
}
